module.exports = {"520113005":"泉湖街道","520113006":"大山洞街道","520113007":"云城街道","520113008":"龚家寨街道","520113009":"都拉营街道","520113100":"艳山红镇","520113101":"麦架镇","520113102":"沙文镇","520113200":"都拉布依族乡","520113201":"牛场布依族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520113.json
// module id = 2583
// module chunks = 0